// extracted by mini-css-extract-plugin
export default {"name":"SWmyQG","price":"i5wupz"};